/* global mixpanel */

export function inventorySupplierStart () {
  mixpanel.track('Inventory Supplier Start')
}

export function inventorySupplierSelect ({supplier}) {
  mixpanel.track('Inventory Supplier Select', {
    'Supplier Name': supplier.name,
    'Supplier Address': supplier.address,
    'Supplier Phone': supplier.phone,
    'Supplier Email': supplier.email
  })
}

export function inventorySupplierCreate ({supplier}) {
  mixpanel.track('Inventory Supplier Create', {
    'Name': supplier.name,
    'Email': supplier.email,
    'Phone': supplier.phone,
    'Address': supplier.address,
    'City': supplier.city,
    'State': supplier.state,
    'Zip': supplier.postal_code
  })
}

export function inventorySupplierDelete ({supplier}) {
  mixpanel.track('Inventory Supplier Delete', {
    'Name': supplier.name,
    'Email': supplier.email,
    'Phone': supplier.phone,
    'Address': supplier.address,
    'City': supplier.city,
    'State': supplier.state,
    'Zip': supplier.postal_code
  })
}

export function inventorySupplierExport () {
  mixpanel.track('Inventory Supplier Export')
}



// WEBPACK FOOTER //
// ./app/mixpanel/inventory/suppliers.js